import React from "react";
import Project from "./Project";

const Projects = () => {
  return (
    <div className="home-content-wrapper">
      <div className="project-content">
        <h1 className="project-title">Projects</h1>
        <div className="project-list">
          <Project
            url="https://sleepy-shirley-38606e.netlify.com/"
            title="Single Page Site"
            largeItem="lg-item"
            sourceCodeTitle="Source Code"
            sourceCode="https://github.com/nunogervasio/spa-v2"
          />
          <Project
            url="https://nyt-api-test.nunogee.now.sh/"
            title="New York Times API"
            sourceCodeTitle="Source Code"
            sourceCode="https://github.com/nunogervasio/new-york-times-api"
          />
          <Project
            url="https://space-x-qmivdzmph.now.sh/"
            title="SpaceX API"
            sourceCodeTitle="Source Code"
            sourceCode="https://github.com/nunogervasio/spacex"
          />
          <Project
            url="https://nunogervasio.github.io/react-scoreboard/"
            title="Scoreboard App"
            largeItem="lg-item"
            sourceCodeTitle="Source Code"
            sourceCode="https://github.com/nunogervasio/react-scoreboard"
          />
        </div>
      </div>
    </div>
  );
};

export default Projects;
